import type { ConfigType, UrlConfigType } from './config.type';

const prodUrls: UrlConfigType = {
  oldPortalUrl: 'https://portal.openenglish.com',
  thirdpartyService: 'https://oe-thirdparty-service-ext.openenglish.com',
  wolverineServiceUrl:
    'https://wolverine-ext.openenglish.com/lp2-wolverine-webapp',
  courseServiceHost: 'https://oe-course-service-ext.openenglish.com',
  progressServiceUrl: 'https://oe-progress-service-ext.openenglish.com',
  profileServiceUrl: 'https://oe-profile-service-ext.openenglish.com',
  accountApiGatewayHost: 'https://oe-account-api-gateway-ext.openenglish.com',
  internalProfileServiceUrl: 'https://oe-profile-service.openenglish.com',
  ssoServiceUrl: 'https://oe-sso-service-ext.openenglish.com',
  internalSsoServiceUrl: 'https://oe-sso-service.openenglish.com',
  liveclassServiceUrl: 'https://oe-liveclass-service-ext.openenglish.com',
  locationServiceUrl: 'https://oe-location-service-ext.openenglish.com',
  privateClassTrackerUrl:
    'https://oe-private-class-tracker-ext.openenglish.com',
  oeContentUrl: 'https://lessons.openenglish.com',
  oeDomain: '.openenglish.com',
  learningPlatform: 'https://learningplatform.openenglish.com',
  leadServiceUrl: 'https://oe-lead-service-ext.openenglish.com',
  myCoachWhatsAppNumber: 'oeapp.myCoach.whatsAppNumber',
  googleTagManagerId: 'GTM-M2QCXR',
  appleSearchAdsCampaignsUrl:
    'https://api.searchads.apple.com/api/v4/campaigns',
  s3RootBucket: 'https://lessons.openenglish.com',
  s3LessonsBucket: 'https://lessons.openenglish.com/commons/resources',
  aiService: 'https://oe-ai-service-ext.openenglish.com',
  bucketUrl:
    'https://oe-content-production.s3.amazonaws.com/content_generator_v2',
  auditService: 'https://oe-audit-service-ext.openenglish.com',
  lp2ContentServicesUrl:
    'https://lp2-content-services-ext.openenglish.com/lp2-content-services-webapp',
  notificationServiceUrl: 'https://oe-notification-service-ext.openenglish.com',
  tsmAuthServiceUrl: 'https://oe-tsm-service-ext.openenglish.com',
  tsmServiceUrl: 'https://oe-tsm-service-ext.openenglish.com',
};

const stgUrls: UrlConfigType = {
  oldPortalUrl: 'https://portal.stg.openenglish.com',
  thirdpartyService: 'https://oe-thirdparty-service-ext.stg.openenglish.com',
  wolverineServiceUrl:
    'https://wolverine-ext.stg.openenglish.com/lp2-wolverine-webapp',
  courseServiceHost: 'https://oe-course-service-ext.stg.openenglish.com',
  progressServiceUrl: 'https://oe-progress-service-ext.stg.openenglish.com',
  profileServiceUrl: 'https://oe-profile-service-ext.stg.openenglish.com',
  accountApiGatewayHost:
    'https://oe-account-api-gateway-ext.stg.openenglish.com',
  internalProfileServiceUrl: 'https://oe-profile-service.stg.openenglish.com',
  liveclassServiceUrl: 'https://oe-liveclass-service-ext.stg.openenglish.com',
  locationServiceUrl: 'https://oe-location-service-ext.stg.openenglish.com',
  privateClassTrackerUrl:
    'https://oe-private-class-tracker-ext.stg.openenglish.com',
  ssoServiceUrl: 'https://oe-sso-service-ext.stg.openenglish.com',
  internalSsoServiceUrl: 'https://oe-sso-service.stg.openenglish.com',
  leadServiceUrl: 'https://oe-lead-service-ext.stg.openenglish.com',
  oeContentUrl: 'https://lessons.openenglish.com',
  oeDomain:
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? 'localhost'
      : '.stg.openenglish.com',
  learningPlatform: 'https://learningplatform.stg.openenglish.com',
  myCoachWhatsAppNumber: 'wa.me/16505145482',
  googleTagManagerId: 'GTM-WMWQ5G',
  appleSearchAdsCampaignsUrl:
    'https://api.searchads.apple.com/api/v4/campaigns',
  s3RootBucket: 'https://lessons.thinkglish.com',
  s3LessonsBucket: 'https://lessons.openenglish.com/commons/resources',
  aiService: 'https://oe-ai-service-ext.stg.openenglish.com',
  bucketUrl:
    'https://oe-content-production.s3.amazonaws.com/content_generator_v2',
  auditService: 'https://oe-audit-service-ext.stg.openenglish.com',
  lp2ContentServicesUrl:
    'https://lp2-content-services-ext.stg.openenglish.com/lp2-content-services-webapp',
  notificationServiceUrl:
    'https://oe-notification-service-ext.stg.openenglish.com',
  tsmAuthServiceUrl: 'https://oe-tsm-service-ext.stg.openenglish.com',
  tsmServiceUrl: 'https://oe-tsm-service-ext.stg.openenglish.com',
};

const addListsToConfig = (list: UrlConfigType): ConfigType => {
  const bearers = [
    'thirdpartyService',
    'wolverineServiceUrl',
    'courseServiceHost',
    'progressServiceUrl',
    'locationServiceUrl',
    'profileServiceUrl',
    'learningPlatform',
    'liveclassServiceUrl',
    'auditService',
    'lp2ContentServicesUrl',
    'notificationServiceUrl',
    'tsmAuthServiceUrl',
    'tsmServiceUrl',
  ];
  const bearerList = Object.entries(list)
    .filter((item) => bearers.includes(item[0]))
    .map((item) => item[1]);

  const authorization = ['aiService'];
  const authorizationList = Object.entries(list)
    .filter((item) => authorization.includes(item[0]))
    .map((item) => item[1]);

  const increasedTimeout = ['aiService'];
  const increasedTimeoutList = Object.entries(list)
    .filter((item) => increasedTimeout.includes(item[0]))
    .map((item) => item[1]);

  return {
    ...list,
    increasedTimeoutList,
    authorizationList,
    bearerList,
  };
};

export const hostsConfig = {
  prod: addListsToConfig(prodUrls),
  stg: addListsToConfig(stgUrls),
};
